import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/Button';

export const NotFound = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="text-center">
          <h1 className="text-9xl font-bold text-primary-600">404</h1>
          <h2 className="mt-4 text-3xl font-bold text-gray-900">页面不存在</h2>
          <p className="mt-2 text-sm text-gray-600">
            抱歉，您访问的页面不存在或已被移除。
          </p>
          <div className="mt-6">
            <Button asChild className="btn-primary">
              <Link to="/">
                返回首页
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};